import classNames from "classnames";
import React from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Body16Medium: React.FC<Props> = ({ children, className }) => {
  const classNamesString = classNames(
    "text-body-16 font-medium leading-body-16 whitespace-nowrap",
    className
  );

  return <p className={classNamesString}>{children}</p>;
};
